import React, { Fragment } from "react";
import { Col } from "react-bootstrap";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

import Concecionarios from "../../assets/concesionarios.png";
import OkDos from "../../assets/okDos.png";

const RazonSiete = () => {
  return (
    <Fragment>
      <Col
        lg={4}
        className="contentCards cardLigth "
        id="razonSiete"
        data-aos="zoom-in"
        data-aos-offset="300"
        data-aos-duration="1000"
        data-aos-easing="ease-out"
      >
        <h4>Razón #7</h4>
        <img
          src={Concecionarios}
          alt="80 Concesionarios"
          className="rounded-circle img-fluid"
          data-aos="fade-up"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        ></img>
        <img
          src={OkDos}
          alt="80 Concesionarios"
          className="okDos"
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        ></img>

        <p
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          La empresa brinda un servicio de postventa activo en más de
        </p>
        <h1
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
            {({ isVisible }) => (
              <div style={{ height: 100 }}>
                {isVisible ? (
                  <CountUp
                    start={0}
                    end={80}
                    duration={1}
                    prefix="+"
                    delay={0}
                  ></CountUp>
                ) : null}
              </div>
            )}
          </VisibilitySensor>
        </h1>
        <p
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          <strong>Concesionarios</strong>
        </p>
      </Col>
    </Fragment>
  );
};

export default RazonSiete;
